import { useState } from 'react';
import type SwiperInstance from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import {
	triggerRecommendedVehiclesNextArrowClicked,
	triggerRecommendedVehiclesPreviousArrowClicked,
} from 'Services/analytics/events';
import type { VehicleListItem } from 'Types/vehicle';

import { SimilarVehiclesCard } from '../SimilarVehiclesCard/SimilarVehiclesCard';

import { SimilarVehiclesCarouselNavigation } from './SimilarVehiclesCarouselNavigation';

import styles from './SimilarVehiclesCarousel.module.scss';

const swiperConfig = {
	slidesPerGroup: 2,
	slidesPerView: 2,
	spaceBetween: 16,
};

interface SimilarVehiclesCarouselProps {
	similarVehicles: VehicleListItem[];
}

export const SimilarVehiclesCarousel: React.FC<SimilarVehiclesCarouselProps> = ({ similarVehicles }) => {
	const [similarVehiclesSwiper, setSimilarVehiclesSwiper] = useState<Nullable<SwiperInstance>>(null);

	const onNextClick = () => {
		similarVehiclesSwiper?.slideNext();
		triggerRecommendedVehiclesNextArrowClicked();
	};

	const onPrevClick = () => {
		similarVehiclesSwiper?.slidePrev();
		triggerRecommendedVehiclesPreviousArrowClicked();
	};

	return (
		<div className={styles.container}>
			<div className={styles.carousel}>
				<Swiper onSwiper={setSimilarVehiclesSwiper} {...swiperConfig}>
					{similarVehicles.map((vehicle, index) => (
						<SwiperSlide key={vehicle.id} className={styles.card} data-index={index}>
							<SimilarVehiclesCard {...vehicle} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className={styles.navigation}>
				<SimilarVehiclesCarouselNavigation
					onSlideNext={onNextClick}
					onSlidePrev={onPrevClick}
					swiperInstance={similarVehiclesSwiper}
				/>
			</div>
		</div>
	);
};
